module.exports = __webpack_public_path__ + "img/vietnam.fe680431.png";